module.exports = __webpack_public_path__ + "img/graines_md.c1bed45b.jpg";